import { getValue as getCustomeValue } from './customeMask';
import { useMoneyMask } from '@redlink/core';

export const useMask = ({ type = 'custome', pattern, getRawValue } = {}) => {
  const {
    getValue: getMoneyValue,
    getRawValue: getMoneyRawValue,
  } = useMoneyMask();
  return {
    getUpdatedValue: (value, oldValue) => {
      switch (type) {
        case 'custome':
          return getCustomeValue(value, pattern);
        case 'money':
          return getMoneyValue(value, oldValue);
        default:
          return null;
      }
    },
    getRawValue: (value) => {
      switch (type) {
        case 'custome':
          return getRawValue(value);
        case 'money':
          return getMoneyRawValue(value);
        default:
          return null;
      }
    },
  };
};
